import React, { useEffect, useState } from "react";
import client from "../../lib/api";
import { Search, ChevronDown } from "lucide-react";

const inp = "bg-[color:var(--app-bg)] border border-[color:var(--border-subtle)] px-3 py-2 text-sm text-white focus:border-gold focus:outline-none";
const dt = (s) => (s ? new Date(s).toLocaleString([], { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "—");

function LeadRow({ l }) {
  const [open, setOpen] = useState(false);
  const pick = l.pick_minutes;
  return (
    <div className="border-b border-[color:var(--border-subtle)] last:border-0" data-testid={`wf-lead-${l.id}`}>
      <button onClick={() => setOpen(!open)} className="w-full px-4 py-3 flex items-center gap-3 text-left text-sm">
        <div className="min-w-0 flex-1">
          <div className="text-white truncate">{l.red_flag && <span className="text-bear mr-1" data-testid={`wf-lead-flag-${l.id}`}>🚩</span>}{l.name}</div>
          <div className="text-[11px] text-slate-500 truncate">{l.status} · {l.assigned_to || "Unassigned"} · {l.source}</div>
        </div>
        <span className={`text-[11px] font-mono shrink-0 ${pick == null ? "text-slate-500" : pick <= 30 ? "text-bull" : "text-bear"}`}>{pick == null ? "not picked" : `${pick}m pick`}</span>
        <ChevronDown size={15} className={`text-slate-500 shrink-0 transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="px-4 pb-4 text-xs">
          <div className="text-slate-500 mb-2">Created {dt(l.created_at)} · Assigned {dt(l.assigned_at)} · First pick {dt(l.first_pick_at)} · Follow-up {dt(l.next_followup)}</div>
          <ol className="border-l border-[color:var(--border-subtle)] pl-3 space-y-1.5">
            {[...(l.activities || [])].reverse().map((a, i) => (
              <li key={i} className="text-slate-300"><span className="text-slate-500 font-mono">{dt(a.at)}</span> · <span className="text-gold">{a.type}</span> · {a.text} <span className="text-slate-500">— {a.by}</span></li>
            ))}
            {!l.activities?.length && <li className="text-slate-500">Koi activity nahi</li>}
          </ol>
        </div>
      )}
    </div>
  );
}

export function LeadHistoryTab() {
  const [partners, setPartners] = useState([]);
  const [f, setF] = useState({ partner_id: "", q: "" });
  const [d, setD] = useState({ total: 0, rows: [] });
  const [skip, setSkip] = useState(0);
  useEffect(() => { client.get("/partners").then(({ data }) => setPartners(data)).catch(() => {}); }, []);
  useEffect(() => {
    const t = setTimeout(() => {
      client.get("/workforce/lead-history", { params: { ...f, skip } }).then(({ data }) => setD((p) => (skip ? { ...data, rows: [...p.rows, ...data.rows] } : data))).catch(() => {});
    }, 300);
    return () => clearTimeout(t);
  }, [f, skip]);
  const set = (k, v) => { setSkip(0); setF({ ...f, [k]: v }); };
  return (
    <div className="space-y-3">
      <div className="grid sm:grid-cols-[1fr_220px] gap-2">
        <div className="relative"><Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
          <input className={`${inp} w-full pl-8`} placeholder="Naam, phone ya email" value={f.q} onChange={(e) => set("q", e.target.value)} data-testid="wf-lead-search" /></div>
        <select className={inp} value={f.partner_id} onChange={(e) => set("partner_id", e.target.value)} data-testid="wf-lead-partner">
          <option value="">Sabhi partners</option>
          {partners.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
        </select>
      </div>
      <div className="text-[11px] text-slate-500" data-testid="wf-lead-total">{d.total} leads</div>
      <div className="surface">{d.rows.map((l) => <LeadRow key={l.id} l={l} />)}</div>
      {d.rows.length < d.total && <button onClick={() => setSkip(d.rows.length)} className="text-xs text-gold hover:underline" data-testid="wf-lead-more">Load more</button>}
    </div>
  );
}
